import { ListItem, ListItemIcon } from "@material-ui/core";
import Button from "@mui/material/Button";
import Icon from "@mdi/react";
import DoneIcon from "@mui/icons-material/Done";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { updatePinBoardSetting } from "actions/project/setting/updatePinBoardSetting";
import { ChartInfoBox } from "components/CustomDonutChart";
import ImprovedSmallProgressBar from "components/ImprovedSmallProgressBar";
import { LightTooltip, TooltipWrapper } from "components/LightTooltip";
import ColumnMembers from "components/WPReactTableViewProjectTask/components/ColumnMembers.js";
import ColumnOptionsGroup from "components/WPReactTableViewProjectTask/components/ColumnOptionsGroup";
import { apiService } from "constants/axiosInstance";
import { statusTaskColors } from "constants/colors";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { get } from "lodash";
import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { IconDrag } from "views/ProjectPage/RightPart/constant/Columns";

import { mdiLink } from "@mdi/js";
import useDrawFocusBorder from "hooks/useDrawFocusBorder";
import { useEffect } from "react";
import useWindowDimensions from "hooks/useWindowDimensions";

export const CellLabel = ({ props, value, onEdit = () => {} }) => {
  const { t } = useTranslation();
  const project_label = props?.row?.original?.project_label;
  console.log(props);
  const location = useLocation();
  const search = location.search;
  const params = new URLSearchParams(search);
  const projectId = params.get("groupID");
  const project = props.row.original;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(project_label);
  const labelsProject = useSelector(
    ({ projectLabels }) => projectLabels.listProjectLabels
  );
  const open = Boolean(anchorEl);
  useDrawFocusBorder(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleSelect = (item) => {
    console.log(item);
    setSelected(item);

    _handleUpdateProject({
      project_id: project.id,
      project_group_id: projectId,
      project_label_id: item?.id || null,
    });
  };

  const _handleUpdateProject = async (data) => {
    try {
      await apiService({
        url: "/project/update",
        method: "PUT",
        data,
      }).then((res) => {
        console.log(res);
      });
      SnackbarEmitter(SNACKBAR_VARIANT.SUCCESS, DEFAULT_MESSAGE.MUTATE.SUCCESS);
    } catch (error) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(error, "messaage", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    }
  };

  const _renderSelected = () => {
    if (!selected)
      return (
        <Label
          className="item_on_hover"
          style={{
            background: "white",
            color: "black",
            width: "auto",
            border: "1px solid #e6e6e6",
          }}
          onClick={handleClick}
        >
          + {t("LABEL_CATEGORY")}
        </Label>
      );
    return (
      <Label
        style={{ background: selected.color, width: "auto" }}
        onClick={handleClick}
      >
        {selected.name}
      </Label>
    );
  };

  return (
    <Box>
      <BoxColLabel onClick={handleClick}>{_renderSelected()}</BoxColLabel>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{
          "& li": {
            background: "#f2f5fa",
          },
        }}
      >
        {labelsProject.data?.projectLabels?.map((item, index) => (
          <MenuItem
            key={index}
            style={{ width: 200 }}
            onClick={() => _handleSelect(item)}
          >
            <DoneIcon
              style={{
                marginRight: 10,
                color: "#666",
                visibility: selected?.id === item.id ? "visible" : "hidden",
              }}
            />
            <Typography
              style={{
                background: item.color,
                padding: "5px 15px",
                borderRadius: "15px",
                color: "#fff",
                fontSize: "12px",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              nowrap
            >
              {item.name}
            </Typography>
          </MenuItem>
        ))}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "#666",
            borderTop: "1px solid#e8ecee",
          }}
        >
          <ListItem onClick={() => onEdit(project)}>
            <ListItemIcon style={{ minWidth: 20 }}>
              <EditIcon />
            </ListItemIcon>
            <span style={{ marginLeft: "5px" }}>Chỉnh sửa</span>
          </ListItem>
        </div>
      </Menu>
    </Box>
  );
};

const CellProgressDay = ({ value }) => {
  if (!value.trim().length) return null;
  const startDate = moment(value, "YYYY/MM/DD");
  const currentDay = moment().startOf("day");
  return `${currentDay.diff(startDate, "days")} ngày`;
};

const CellNameProject = React.memo(({ props, onEdit = () => {} }) => {
  const row = props.row.original;
  const dispatch = useDispatch();
  const [pined, setPined] = React.useState(row?.pinded_personal_board);

  const _handlePin = () => {
    dispatch(
      updatePinBoardSetting({
        projectId: row.id,
        status: pined,
      })
    );
    setPined(!pined);
  };

  return (
    <WrapperCellName>
      {pined ? (
        <StarOutlineRoundedIcon
          className="star-icon"
          onClick={_handlePin}
          style={{ cursor: "pointer", margin: "0 5px" }}
        />
      ) : (
        <StarRoundedIcon
          className="star-icon"
          onClick={_handlePin}
          style={{ cursor: "pointer", margin: "0 5px", color: "yellow" }}
        />
      )}

      {
        //   <CustomAvatar
        //   style={{ width: 25, height: 25 }}
        //   className="avatar"
        //   src={props.row.original.icon}
        //   alt="avatar"
        // />
      }
      <Link
        to={props.row.original.url_redirect}
        className={"view_ProjectGroup_Table_All_title_bold"}
        style={{
          // minWidth: "140px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
        }}
      >
        {props.value}
      </Link>
    </WrapperCellName>
  );
});

const CellMoreProject = React.memo(({ props, onEdit = () => {} }) => {
  const row = props.row.original;
  const isDisplayUpdate =
    get(row, "can_update", false) || get(row, "can_delete", false);
  const dispatch = useDispatch();

  const _handlePin = () => {
    dispatch(updatePinBoardSetting({ projectId: row.id, status: 0 }));
  };

  return (
    <WrapperCellName>
      {isDisplayUpdate && (
        <div
          className="wp-wrapper-button"
          onClick={(evt) => onEdit(evt.currentTarget, row)}
        >
          <MoreVertIcon />
        </div>
      )}
    </WrapperCellName>
  );
});

const CellProgressSuccess = ({ props }) => {
  const { t } = useTranslation();
  const data = props.row.original;
  return (
    <LightTooltip
      className={"view_ProjectGroup_Table_All___progress"}
      placement="top"
      title={
        <ChartInfoBox
          className="view_ProjectGroup_Table_All___tooltip"
          title={t("DMH.VIEW.PGP.RIGHT.ALL.STATS.TOTAL")}
          data={[
            {
              color: statusTaskColors.waiting,
              title: t("DMH.VIEW.PGP.RIGHT.ALL.STATS.WAITING"),
              value: get(data, "statistic.waiting", 0),
            },
            {
              color: statusTaskColors.doing,
              title: t("DMH.VIEW.PGP.RIGHT.ALL.STATS.DOING"),
              value: get(data, "statistic.doing", 0),
            },
            {
              color: statusTaskColors.complete,
              title: t("DMH.VIEW.PGP.RIGHT.ALL.STATS.COMPLETE"),
              value: get(data, "statistic.complete", 0),
            },
            {
              color: statusTaskColors.expired,
              title: t("DMH.VIEW.PGP.RIGHT.ALL.STATS.EXPIRED"),
              value: get(data, "statistic.expired", 0),
            },
            {
              color: statusTaskColors.stoped,
              title: t("DMH.VIEW.PGP.RIGHT.ALL.STATS.STOP"),
              value: get(data, "statistic.stop", 0),
            },
          ]}
        />
      }
    >
      <TooltipWrapper>
        <ImprovedSmallProgressBar
          data={[
            {
              color: "#ff9800",
              value: get(data, "statistic.waiting", 0),
            },
            {
              color: "#03a9f4",
              value: get(data, "statistic.doing", 0),
            },
            {
              color: "#f44336",
              value: get(data, "statistic.expired", 0),
            },
            {
              color: "#03c30b",
              value: get(data, "statistic.complete", 0),
            },
            {
              color: "#607d8b",
              value: get(data, "statistic.stop", 0),
            },
          ]}
          color={"#05b50c"}
          percentDone={get(data, "complete", 0)}
        />
      </TooltipWrapper>
    </LightTooltip>
  );
};

export const CellStatus = ({ props }) => {
  const { t } = useTranslation();
  const row = props.row.original;
  const getColor = (code) => {
    switch (code) {
      case 0:
        return "#ff9800";
      case 1:
        return "#03a9f4";
      case 2:
        return "#03c30b";
      case 3:
        return "#f44336";
      case 4:
        return "#607d8b";
      case 5:
        return "#20194d";
      default:
        return "";
    }
  };
  return (
    <BoxColLabel>
      <LabelColumnOption
        style={{ background: getColor(get(row, "state_code")) }}
      >
        {get(row, "state_code") === 5
          ? t("DMH.VIEW.PGP.RIGHT.ALL.HIDE")
          : get(row, "state_name")}
      </LabelColumnOption>
    </BoxColLabel>
  );
};

const CellTotalTask = ({ value }) => {
  if (!value.total_task) return null;
  return (
    <WrapperCellTotal>
      <DonutSmallIcon />
      <span>{value.total_task}</span>
    </WrapperCellTotal>
  );
};

export const CellPriority = ({ value, props }) => {
  const row = props.row.original;
  const options = [
    { id: 1, _id: 1, name: "Thấp", value: 0, color: "#03C30B" },
    { id: 2, _id: 2, name: "Trung bình", value: 1, color: "#FF9800" },
    { id: 3, _id: 3, name: "Cao", value: 2, color: "#ff0000" },
  ];
  const selected =
    options.find((item) => item.value === row.priority_code) || {};
  return (
    <ColumnOptionsGroup
      defaultSelected={selected}
      options={options}
      project={row}
    />
  );
};

const CellLinkProject = React.memo(({ props, onEdit = () => {} }) => {
  const { t } = useTranslation();

  const handleCopyText = (text) => {
    window.navigator.clipboard
      .writeText(window.location.hostname + text)
      .then((r) => null);
    SnackbarEmitter(
      SNACKBAR_VARIANT.SUCCESS,
      `${t("IDS_WP_ALREADY_COPY")} link`
    );
  };

  return (
    <Box>
      <Button
        variant={"contained"}
        style={{
          background: "#fff",
          color: "#888888",
          textTransform: "none",
        }}
        disableElevation
        size="small"
        onClick={() => handleCopyText(props.row.original.url_redirect)}
      >
        <Icon path={mdiLink} size={1} color={"#a4a4a4"} />
      </Button>
    </Box>
  );
});

export const COLUMNS_PROJECT_TABLE = ({
  onEdit = () => {},
  onOpenEditModal = () => {},
  openEditLabel = () => {},
}) => {
  return [
    {
      id: "name",
      Header: "Bảng việc",
      accessor: "name",
      headerClassName: "sticky",
      width: 240,
      sticky: "left",
      Cell: (props) => <CellNameProject props={props} onEdit={onEdit} />,
    },

    {
      id: "midle_model",
      Header: "Ưu tiên",
      width: "auto",
      accessor: "midle_model",
      Cell: (props) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CellLabel props={props} onEdit={openEditLabel} />
          <CellPriority props={props} />
          <CellStatus props={props} />
        </Box>
      ),
    },
    {
      id: "members",
      Header: "Thành viên",
      accessor: "members",
      width: "100%",
      Cell: (props) => {
        const valueCell = props.row.original;
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ColumnMembers dataCell={valueCell} value={props.value} />
            <CellLinkProject props={props} onEdit={onEdit} />
            <CellMoreProject props={props} onEdit={onEdit} />
          </Box>
        );
      },
    },
  ];
};

export const RowProjectTable = ({
  onEdit = () => {},
  onOpenEditModal = () => {},
  openEditLabel = () => {},
  row = {},
  isShared = false,
  dataRows = [],
  expand = true,
}) => {
  const [hovering, setHovering] = React.useState(false);
  return (
    <Box
      sx={{
        display: "grid",
        width: "100%",
        gridTemplateColumns: "5fr 4fr 1fr",
      }}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <CellNameProjectCustom props={row} isShared={isShared} expand={expand} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
        }}
      >
        <CellLabelCustom
          props={row}
          hovering={hovering}
          onEdit={openEditLabel}
          setHovering={setHovering}
          isShared={isShared}
          dataRows={dataRows}
        />
        <CellPriorityCustom
          props={row}
          hovering={hovering}
          setHovering={setHovering}
          isShared={isShared}
        />
        <CellStatusCustom props={row} />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
        }}
      >
        <ColumnMembers dataCell={row} value={row.members} isShared={isShared} />
        <CellLinkProjectCustom props={row} />
        <CellMoreProjectCustom props={row} onEdit={onEdit} />
      </Box>
    </Box>
  );
};

const CellMoreProjectCustom = ({ props: row, onEdit = () => {} }) => {
  const isDisplayUpdate =
    get(row, "can_update", false) || get(row, "can_delete", false);

  return (
    <WrapperCellName key={row.id}>
      {isDisplayUpdate ? (
        <div key={row.id}>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(evt) => onEdit(evt.currentTarget, row)}
            size="medium"
            className="wp-wrapper-button"
          >
            <MoreVertIcon />
          </Button>
        </div>
      ) : (
        // <div className="wp-wrapper-button"></div>
        <Box sx={{ width: "28px", height: "28px" }}></Box>
      )}
    </WrapperCellName>
  );
};

const CellLinkProjectCustom = React.memo(({ props: row }) => {
  const { t } = useTranslation();

  const handleCopyText = (text) => {
    window.navigator.clipboard
      .writeText(window.location.hostname + text)
      .then((r) => null);
    SnackbarEmitter(
      SNACKBAR_VARIANT.SUCCESS,
      `${t("IDS_WP_ALREADY_COPY")} link`
    );
  };

  return (
    <Box>
      <Button
        // variant={"contained"}
        sx={{
          "&": {
            height: "28px",
            minHeight: "28px",
            minWidth: "28px",
            width: "28px",
            borderRadius: "6px",
            justifyContent: "center",
            fill: "#6f7782",
            color: "#888888",
            textTransform: "none",
          },
          "&:hover": {
            background: "rgba(0, 0, 0, 0.1294117647)",
            fill: "#151b26",
            cursor: "pointer",
          },
        }}
        disableElevation
        size="small"
        onClick={() => handleCopyText(row.url_redirect)}
      >
        <Icon path={mdiLink} size={1} color={"#a4a4a4"} />
      </Button>
    </Box>
  );
});

export const CellStatusCustom = ({ props: row }) => {
  const { t } = useTranslation();
  const getColor = (code) => {
    switch (code) {
      case 0:
        return "#ff9800";
      case 1:
        return "#03a9f4";
      case 2:
        return "#03c30b";
      case 3:
        return "#f44336";
      case 4:
        return "#607d8b";
      case 5:
        return "#20194d";
      default:
        return "";
    }
  };
  return (
    <BoxColStatus>
      <LabelColumnOption
        style={{ background: getColor(get(row, "state_code")) }}
      >
        {get(row, "state_code") === 5
          ? t("DMH.VIEW.PGP.RIGHT.ALL.HIDE")
          : get(row, "state_name")}
      </LabelColumnOption>
    </BoxColStatus>
  );
};

export const CellPriorityCustom = ({
  props: row,
  hovering = false,
  setHovering,
  isShared = false,
}) => {
  const options = [
    { id: 1, _id: 1, name: "Thấp", value: 0, color: "#03C30B" },
    { id: 2, _id: 2, name: "Trung bình", value: 1, color: "#FF9800" },
    { id: 3, _id: 3, name: "Cao", value: 2, color: "#ff0000" },
  ];

  const selected =
    options.find((item) => item.value === row.priority_code) || {};
  return (
    <ColumnOptionsGroup
      defaultSelected={selected}
      options={options}
      project={row}
      hovering={hovering}
      setHovering={setHovering}
      isShared={isShared}
    />
  );
};

export const CellLabelCustom = ({
  props: row,
  onEdit = () => {},
  hovering = false,
  setHovering,
  isShared = false,
  dataRows = [],
}) => {
  const isDisplayUpdate =
    get(row, "can_update", false) || get(row, "can_delete", false);
  const { t } = useTranslation();
  const project_label = row?.project_label;
  const location = useLocation();
  const search = location.search;
  const params = new URLSearchParams(search);
  const projectId = params.get("groupID");
  const project = row;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(project_label);
  const labelsProject = useSelector(
    ({ projectLabels }) => projectLabels.listProjectLabels
  );

  const open = Boolean(anchorEl);
  useDrawFocusBorder(anchorEl);

  const handleClick = (event) => {
    if (isShared || !isDisplayUpdate) return;
    setAnchorEl(event.currentTarget);
    setHovering(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleSelect = (item) => {
    _handleUpdateProject(
      {
        project_id: project.id,
        project_label_id: item?.id || null,
      },
      item
    );
  };

  const _handleUpdateProject = async (data, item) => {
    try {
      await apiService({
        url: "/project/update-label",
        method: "PUT",
        data,
      }).then((res) => {
        console.log(res);
        setSelected(item);
        setHovering(false);
      });
      SnackbarEmitter(SNACKBAR_VARIANT.SUCCESS, DEFAULT_MESSAGE.MUTATE.SUCCESS);
    } catch (error) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(error, "messaage", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    }
  };

  const _renderSelected = () => {
    if ((!selected || hovering) && isDisplayUpdate && !isShared)
      return (
        <Label
          className="item_on_hover"
          style={{
            background: "white",
            color: "black",
            width: "auto",
            border: "1px solid #e6e6e6",
          }}
          onClick={handleClick}
        >
          + {t("LABEL_CATEGORY")}
        </Label>
      );
    return (
      <Label style={{ background: selected?.color }} onClick={handleClick}>
        {selected?.name}
      </Label>
    );
  };

  return (
    <Box>
      <BoxColLabel onClick={handleClick}>{_renderSelected()}</BoxColLabel>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          key={""}
          sx={{
            width: "200px",
            "&:hover": {
              background: "#f2f5fa !important",
            },
          }}
          onClick={() => _handleSelect(null)}
        >
          <div style={{ width: 38 }} /> -
        </MenuItem>
        {labelsProject.data?.projectLabels?.map((item, index) => (
          <MenuItem
            key={index}
            sx={{
              width: "200px",
              "&:hover": {
                background: "#f2f5fa !important",
              },
            }}
            onClick={() => _handleSelect(item)}
          >
            <DoneIcon
              style={{
                marginRight: 10,
                color: "#666",
                visibility: selected?.id === item.id ? "visible" : "hidden",
              }}
            />
            <Typography
              style={{
                background: item.color,
                padding: "5px 15px",
                borderRadius: "15px",
                color: "#fff",
                fontSize: "12px",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              nowrap
            >
              {item.name}
            </Typography>
          </MenuItem>
        ))}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "#666",
            borderTop: "1px solid#e8ecee",
          }}
        >
          <ListItem onClick={() => onEdit(project)}>
            <ListItemIcon style={{ minWidth: 20 }}>
              <EditIcon />
            </ListItemIcon>
            <span style={{ marginLeft: "5px" }}>{t("update")}</span>
          </ListItem>
        </div>
      </Menu>
    </Box>
  );
};

const CellNameProjectCustom = React.memo(
  ({ props: row, isShared = false, expand = true }) => {
    console.log(expand, "expand name");
    const dispatch = useDispatch();
    const [pined, setPined] = React.useState(row?.pinded_personal_board);
    const { width: widthWindow } = useWindowDimensions();
    const ellipse = !expand
      ? widthWindow < 1630
        ? true
        : false
      : widthWindow < 1400
      ? true
      : false;
    const _handlePin = () => {
      dispatch(
        updatePinBoardSetting({
          projectId: row.id,
          status: pined,
        })
      );
      setPined(!pined);
    };
    console.log(row, "row");
    return (
      <WrapperCellName>
        {!isShared ? (
          !pined ? (
            <StarOutlineRoundedIcon
              // className="star-icon"
              onClick={_handlePin}
              sx={{
                cursor: "pointer",
                margin: "0 15px 0 0",
                padding: "5px",
                borderRadius: "50%",
                color: "#ccc",
                "&:hover": {
                  color: "#ff9800",
                },
              }}
            />
          ) : (
            <StarRoundedIcon
              // className="star-icon"
              onClick={_handlePin}
              sx={{
                cursor: "pointer",
                margin: "0 15px 0 0",
                padding: "5px",
                borderRadius: "50%",
                color: "#ff9800",
                "&:hover": {
                  color: "rgba(219, 219, 219, 1)",
                },
              }}
            />
          )
        ) : (
          <></>
        )}
        {row?.icon_url && (
          <Box
            sx={{
              background: row?.group_color ?? "transparent",
              borderRadius: "10px",
              padding: "7px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "& img": {
                width: "20px",
                height: "20px",
              },
            }}
          >
            <img src={row?.icon_url} />
          </Box>
        )}
        <Box
          sx={{
            "& a": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              color: "#070707",
              marginLeft: "8px",
              fontWeight: "normal !important",
              fontSize: "14px",
              ...(ellipse && { width: "300px" }),
            },
          }}
        >
          <Link
            to={row.url_redirect}
            className={"view_ProjectGroup_Table_All_title_bold"}
          >
            {row.name}
          </Link>
        </Box>
      </WrapperCellName>
    );
  }
);

const Label = styled.div`
  padding: 3px 10px;
  border-radius: 15px;
  color: #fff;
  max-width: 100%;
  margin: 0px 5px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
`;

const WrapperCellTotal = styled.div`
  display: flex;
  align-items: center;
  color: #6f7782;
  span {
    margin-left: 10px;
  }
`;

const WrapperCellName = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  justify-content: flex-start;

  .drag-icon {
    height: 19.5px;
    position: absolute;
    left: 5px;
  }
  .drag-icon {
    opacity: 0;
  }
  .star-icon {
    opacity: 1;
  }
  .wp-wrapper-button {
    visibility: hidden;
    min-width: 28px;
  }

  &:hover {
    .drag-icon {
      opacity: 1;
    }
  }
  .star-icon:hover {
    color: #05b50c;
  }
  a {
    color: #666;
    display: inline-flex;
    margin-left: 8px;
    font-weight: 400 !important;
    &:hover {
      color: #666;
    }
  }
`;
const BoxColLabel = styled(Box)`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  cursor: pointer;
  .default_tag,
  .icon {
    visibility: hidden;
  }
  &:hover {
    .default_tag,
    .icon {
      visibility: visible;
    }
  }
`;

const BoxColStatus = styled(Box)`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  .default_tag,
  .icon {
    visibility: hidden;
  }
  &:hover {
    .default_tag,
    .icon {
      visibility: visible;
    }
  }
`;

const LabelColumnOption = styled.div`
  padding: 3px 10px;
  border-radius: 15px;
  color: #fff;
  max-width: 100%;
  margin: 0px 5px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
`;
